/** In-memory cache so Manage Account tabs render instantly when returning from other sidebar routes. */

const TTL_MS = 10 * 60 * 1000;

type CacheEntry<T> = {
  data: T;
  at: number;
};

const store = new Map<string, CacheEntry<unknown>>();

export function getManageAccountCacheKey(
  userId?: string | number | null,
  tenantSlug?: string | null
): string {
  return `${userId ?? 'anon'}:${(tenantSlug ?? '').trim().toLowerCase()}`;
}

export function readManageAccountCache<T>(namespace: string, key: string): T | null {
  const entry = store.get(`${namespace}:${key}`);
  if (!entry) {
    return null;
  }
  if (Date.now() - entry.at > TTL_MS) {
    store.delete(`${namespace}:${key}`);
    return null;
  }
  return entry.data as T;
}

export function writeManageAccountCache<T>(namespace: string, key: string, data: T): void {
  store.set(`${namespace}:${key}`, { data, at: Date.now() });
}

/** Fired after subscription cancel/reactivate so Dashboard and other tabs refetch status. */
export const MANAGE_ACCOUNT_SUBSCRIPTION_CHANGED_EVENT = 'manageAccount:subscriptionChanged';

/** Drop cached Manage Account payloads so Feature Limits / usage refetch after mutations. */
export function clearManageAccountCache(namespace: string, key?: string): void {
  if (key != null && key !== '') {
    store.delete(`${namespace}:${key}`);
    return;
  }
  const prefix = `${namespace}:`;
  for (const storeKey of Array.from(store.keys())) {
    if (storeKey.startsWith(prefix)) {
      store.delete(storeKey);
    }
  }
}
